const TipoDocumentoEnum = {
    NORMAL: 1,
    INTERCAMBIO: 2
};

export default TipoDocumentoEnum;
